export enum ClientsActions {
    SET_CLIENTS = "setSelectedClients",
    CLEAR_LIST_DATA = "clearListData",
    SET_ACTIVE_CLIENT = "setActiveClient",
    RELOAD_DATA = "reloadData",
    TOGGLE_PANEL = "togglePanel",
    SET_CLIENT_ORDER_TYPE = "setClientOrderType",
    ADD_NEW_CLIENT = "addNewCLient",
    TOGGLE_DEACTIVATION_REASON = "toggleDeactivationReason"
  }